import React from 'react';

import { MenuItem as MuiMenuItem, styled } from '@mui/material';

import theme from '../../config/theme';

const MenuItem = styled(MuiMenuItem)(() => ({
  [theme.breakpoints.down('lg')]: {
    fontSize: 10,
  },
}));

type PropTypes = {
  text: string;
  handleClick: () => void;
};

export default function CustomMenuItem(props: PropTypes) {
  const { handleClick, text } = props;

  return <MenuItem onClick={handleClick}>{text}</MenuItem>;
}
